import React, { Suspense, lazy, useEffect } from "react";
import { AppBar, Tabs, Tab, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";

const AboutMillionDeals = lazy(() =>
  import("./about-million-deals/AboutMillionDeals")
);
const WorkWithUs = lazy(() => import("./work-with-us/WorkWithUs"));
const OurTeam = lazy(() => import("./teams/Team"));
const Advisors = lazy(() => import("./advisors/Advisors"));
const Partners = lazy(() => import("./partners/Partners"));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function allyProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const AboutUs = () => {
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    dispatch({ type: "GET_LINK", payload: "/abouts" });
  }, [dispatch]);
  return (
    <div style={{ marginTop: "5px", padding: "8px" }}>
      <AppBar
        position="static"
        style={{ backgroundColor: "#0b6885", padding: "0px" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
          style={{ borderRadius: 0 }}
          TabIndicatorProps={{ style: { height: "50px", opacity: 0.2 } }}
        >
          <Tab
            style={{ fontSize: "13px", color: "#ffffff", fontWeight: "600" }}
            label="About-Us"
            {...allyProps(0)}
          />

          <Tab
            style={{ fontSize: "13px", color: "#ffffff", fontWeight: "600" }}
            label="Work With us"
            {...allyProps(1)}
          />
          <Tab
            style={{ fontSize: "13px", color: "#ffffff", fontWeight: "600" }}
            label="Our Team"
            {...allyProps(2)}
          />
          <Tab
            style={{ fontSize: "13px", color: "#ffffff", fontWeight: "600" }}
            label="Our Advisors"
            {...allyProps(3)}
          />
          <Tab
            style={{ fontSize: "13px", color: "#ffffff", fontWeight: "600" }}
            label="Our Partners"
            {...allyProps(4)}
          />
        </Tabs>
      </AppBar>
      <Suspense fallback={<div></div>}>
        <TabPanel value={value} index={0}>
          <AboutMillionDeals />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <WorkWithUs />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <OurTeam />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Advisors />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <Partners />
        </TabPanel>
      </Suspense>
    </div>
  );
};

export default AboutUs;
